import axios from 'axios'
import {useState} from 'react'

export function register(payload){
    return async function(dispatch){
        try {
            if(window.location.href.slice(0,16) !== 'http://localhost'){
                const res= await axios.post('https://bloque-back.vercel.app/signup',payload)
                return res
            }else{
                const res= await axios.post('http://localhost:4200/signup',payload)
                return res
            }
            // console.log(res,'regis')
        } catch (error) {
            console.log(error)
        }

    }
}
export function login(payload){
    return async function(dispatch){
        try {
            if (window.location.href.slice(0,16) !== 'http://localhost') {
                const res= await axios.post('https://bloque-back.vercel.app/login',payload)
                return res
                
            } else {
                const res= await axios.post('http://localhost:4200/login',payload)
                // console.log(res,'login')
                return res
                
            }
        } catch (error) {
         console.log(error)   
        }

    }
}
export function getProp(propietarios){
    return async function(dispatch){
        try {
            if (window.location.href.slice(0,16) !== 'http://localhost') {
                const res=(await axios.get(`https://bloque-back.vercel.app/departamentoprop/${propietarios}`)).data
                return dispatch({
                    type:'GET_PROP',
                    payload:res
                })
                
            } else {
                const res=(await axios.get(`http://localhost:4200/departamentoprop/${propietarios}`)).data
                return dispatch({
                    type:'GET_PROP',
                    payload:res
                })
                
            }
        } catch (error) {
            console.log(error)
        }
    }
}
export function getEdById(id){
    return async function(dispatch){
        try {
            if (window.location.href.slice(0,16) !== 'http://localhost') {
                const res=(await axios.get(`https://bloque-back.vercel.app/edificio/${id}`)).data
                return dispatch({
                    type:'GET_ED_ID',
                    payload:res
                })
                
            } else {
                
                const res=(await axios.get(`http://localhost:4200/edificio/${id}`)).data
                return dispatch({
                    type:'GET_ED_ID',
                    payload:res
                })
            }
        } catch (error) {
            console.log(error)
        }
    }
}
export function getUserByEmail(payload){
    return async function(dispatch){
        try {
            if (window.location.href.slice(0,16) !== 'http://localhost') {
                const res= await axios.get(`https://bloque-back.vercel.app/user?email=${payload}`)
                return res
                
            } else {
                const res= await axios.get(`http://localhost:4200/user?email=${payload}`)
                // console.log(res,'login')
                return res
                
            }
        } catch (error) {
         console.log(error)   
        }

    }
}